import { render, staticRenderFns } from "./SelectRelation.vue?vue&type=template&id=864a48bc"
import script from "./SelectRelation.vue?vue&type=script&lang=js"
export * from "./SelectRelation.vue?vue&type=script&lang=js"
import style0 from "./SelectRelation.vue?vue&type=style&index=0&id=864a48bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports